// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"3f083c2a","234":"1eb99b56"}[chunkId] + ".chunk.js";
};